// extracted by mini-css-extract-plugin
export default {"wrapper":"fC2Qnzjg","mobile":"mobile","signed":"O8aL7JvP","title":"pgww82gW","text":"AHNfwNxS","button":"oAhUuIGM","additionalTopics":"UoVtTI6b","additionalTopicsTitle":"gYMmeW94"};